import { FormField } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormEntityContext } from '../../config/context/forms'
import FieldWrapper from './FieldWrapper'
import { Textarea } from '@/components/ui/textarea'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string
  layout?: 'box' | 'inline' | 'stacked'
  multiline?: boolean
  className?: string
  inputClassName?: string
  customPlaceholder?: string
  customLabel?: string
  customDescription?: string
  resetValue?: string
  disabled?: boolean
}

const TextField = ({
  customLabel,
  customDescription,
  customPlaceholder,
  className,
  inputClassName,
  name,
  layout = 'inline',
  multiline,
  resetValue,
  disabled = false,
  ...inputProps
}: Props) => {
  const { i18n, t } = useTranslation()
  const form = useFormContext()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  const description =
    customDescription ??
    (i18n.exists(`${i18nPrefix}.${entityType}.${name}.description`)
      ? t(`${i18nPrefix}.${entityType}.${name}.description`)
      : undefined)

  return (
    <div className={`${className ?? ''} w-full`}>
      <FormField
        control={form.control}
        disabled={disabled}
        name={name}
        render={({ field }) => {
          return (
            <FieldWrapper
              layout={layout}
              label={
                customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
              }
              description={description}
              resetValue={resetValue}
            >
              {multiline ? (
                <Textarea
                  disabled={disabled}
                  className='min-h-[140px]'
                  placeholder={t(
                    customPlaceholder ??
                      `${i18nPrefix}.${entityType}.${name}.placeholder`,
                  )}
                  {...field}
                />
              ) : (
                <Input
                  type={'text'}
                  disabled={disabled}
                  placeholder={t(
                    customPlaceholder ??
                      `${i18nPrefix}.${entityType}.${name}.placeholder`,
                  )}
                  className={`${
                    layout === 'box'
                      ? 'absolute right-3 top-1.5 w-24 bg-muted z-20'
                      : ''
                  } ${inputClassName ?? ''}`}
                  {...field}
                  {...inputProps}
                />
              )}
            </FieldWrapper>
          )
        }}
      />
    </div>
  )
}

export default TextField
